import { render } from "./AddGpsCamera.vue?vue&type=template&id=147bd56e"
import script from "./AddGpsCamera.vue?vue&type=script&lang=js"
export * from "./AddGpsCamera.vue?vue&type=script&lang=js"
script.render = render

export default script